import React, { forwardRef } from 'react';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  className?: string;
}

/**
 * Componente TextArea reutilizable con diseño consistente con Input
 */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((
  { label, error, className = '', ...props },
  ref
) => {
  const textAreaClasses = `
    w-full px-4 py-3 
    bg-secondary-700 border-0
    rounded-lg text-secondary-50 placeholder-secondary-400
    focus:outline-none focus:ring-4 focus:ring-primary-500
    transition-all duration-200 ease-in-out
    disabled:opacity-50 disabled:cursor-not-allowed
    text-base
    hover:bg-secondary-600
    resize-none
    ${error ? 'focus:ring-red-500' : ''}
    ${className}
  `;

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-secondary-50 mb-2">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        className={textAreaClasses}
        {...props}
      />
      {error && (
        <p className="mt-2 text-sm text-red-400 font-medium">{error}</p>
      )}
    </div>
  );
});

TextArea.displayName = 'TextArea';
export default TextArea;